export const COMPENSATION_TYPE_LABELS: Record<string, string> = {
  compensation: "Compensation",
  reward: "Reward",
  other_credit: "Other Credit",
  balance_transfer_credit: "Balance Transfer Credit",
  adjustment: "Adjustment",
};

export const CONFISCATION_TYPE_LABELS: Record<string, string> = {
  fund_confiscation: "Fund confiscation",
  other_debit: "Other debit",
  balance_transfer_debit: "Balance transfer debit",
};

export const displayValue = (value?: string | number | null) =>
  value === undefined || value === null || value === "" ? "—" : value;

export const getCellText = (value?: string | number | null) => {
  const display = String(displayValue(value));

  if (display === "—") {
    return {
      display,
      title: undefined,
    };
  }

  return {
    display,
    title: display,
  };
};

export const truncateComment = (text?: string | null, maxLength = 25) => {
  if (!text) {
    return { display: "—", title: undefined };
  }

  if (text.length <= maxLength) {
    return { display: text, title: undefined };
  }

  return {
    display: `${text.slice(0, maxLength)}…`,
    title: text,
  };
};
